import { type FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type ProfileVerifiedBadge_profile$key } from '@/__generated__/ProfileVerifiedBadge_profile.graphql'
import { VerifiedBadge, type VerifiedBadgeProps } from '@/components'

export interface ProfileVerifiedBadgeProps extends VerifiedBadgeProps {
  profileRef: ProfileVerifiedBadge_profile$key | null | undefined
}

export const ProfileVerifiedBadge: FC<ProfileVerifiedBadgeProps> = ({ profileRef, ...props }) => {
  const profileData = useFragment(
    graphql`
      fragment ProfileVerifiedBadge_profile on Profile {
        isVerified
      }
    `,
    profileRef
  )

  if (!profileData?.isVerified) {
    return null
  }

  return <VerifiedBadge {...props} />
}
